// Скоринг финансового здоровья: круговая шкала, вердикт словом и три
// составляющие балла с пояснением и целью.

import type { HealthScore } from '../../api/types';
import { Gauge } from '../charts/Gauge';

type Props = {
  health: HealthScore;
};

const CLASS_LABELS: Record<HealthScore['overall_class'], string> = {
  excellent: 'Отлично',
  good: 'Хорошо',
  fair: 'Осторожно',
  poor: 'Критично',
};

export function HealthScoreCard({ health }: Props): JSX.Element {
  return (
    <div className="health-card">
      <div className="health-top">
        <Gauge value={health.overall} label="из 100" />
        {/* Вердикт — слово цветом состояния, а не залитая плашка: залитыми
            плашками на этих экранах ничего не обозначается, и на светлой теме
            бежевый овал с оранжевым текстом читался как мутное пятно. */}
        <div className="health-class" data-class={health.overall_class}>
          {CLASS_LABELS[health.overall_class]}
        </div>
      </div>

      <div className="health-subs">
        <SubScore
          label="Расходы"
          value={health.spend_score}
          note={health.notes.spend}
          target="цель 20%"
        />
        <SubScore
          label="Долги"
          value={health.borrow_score}
          note={health.notes.borrow}
          target="цель < 30%"
        />
        {/* Само число подушки живёт в карточке ниже — здесь только цель,
            иначе «0.0 мес» стояло бы на экране дважды. */}
        <SubScore
          label="Подушка"
          value={health.save_score}
          note={health.notes.save}
          target="цель 3+ мес"
        />
      </div>
    </div>
  );
}

function SubScore({
  label,
  value,
  note,
  target,
}: {
  label: string;
  value: number;
  note: string;
  target: string;
}): JSX.Element {
  let cls: 'good' | 'mid' | 'bad';
  if (value >= 70) cls = 'good';
  else if (value >= 40) cls = 'mid';
  else cls = 'bad';
  return (
    <div className={`subscore subscore-${cls}`}>
      <div className="subscore-head">
        <span className="subscore-label">{label}</span>
        <span className="subscore-value">{Math.round(value)}</span>
      </div>
      <div className="subscore-bar">
        <div className="subscore-bar-fill" style={{ width: `${Math.min(100, value)}%` }} />
      </div>
      {/* Пояснение и цель в одной строке: число без цели не говорит, что делать,
          а цель отдельной карточкой уводила его на пол-экрана от самого числа. */}
      <div className="subscore-note">
        <span>{note}</span>
        <span className="subscore-target">{target}</span>
      </div>
    </div>
  );
}
